"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var PercentageBar_styles_1 = require("./PercentageBar.styles");
var between = function (value, max, min) {
    if (min === void 0) { min = 0; }
    return Math.min(Math.max(min, value), max);
};
var PercentageBar = function (_a) {
    var label = _a.label, title = _a.title, percentage = _a.percentage, _b = _a.className, className = _b === void 0 ? "" : _b, onClick = _a.onClick;
    var classes = (0, PercentageBar_styles_1.useStyles)();
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "".concat(classes.wrapper, " ").concat(className), title: title, onClick: function () { return onClick === null || onClick === void 0 ? void 0 : onClick(); } }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: classes.label }, { children: label })), (0, jsx_runtime_1.jsxs)("span", __assign({ className: classes.value }, { children: [percentage, "%"] })), (0, jsx_runtime_1.jsx)("span", __assign({ className: classes.bar }, { children: (0, jsx_runtime_1.jsx)("span", { className: classes.inner, style: { width: between(percentage, 100) + "%" } }) }))] })));
};
exports.default = PercentageBar;
